import { GetUserLocationWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('GetUserLocation')
export class GetUserLocationConnectorProvider extends ConnectorProvider<GetUserLocationWorkflowNode> {}
